export default (fallback = String) =>
  error => ({
    error: {
      message: typeof error === 'object' ? error.message || fallback(error) : fallback(error)
    }
  });
